import { Directive, OnInit, OnDestroy, inject } from '@angular/core';
import { ToolBarButtonComponent } from '@progress/kendo-angular-toolbar';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { DialogService } from '@app/services';
import { InsertLinkModalComponent } from '@app/pages/main/pages/quality/components/shared/editor/modals/insert-link-modal/insert-link-modal.component';
import { Subscription } from 'rxjs';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'kendo-toolbar-button[createLinkDirective]',
})
export class CreateLinkDirective implements OnInit, OnDestroy {
  private button = inject(ToolBarButtonComponent);
  private dialogService = inject(DialogService);
  private editor = inject(EditorComponent, { host: true });

  readonly strings = tiStrings.modules.quality.incidents;
  private sub = new Subscription();

  ngOnInit(): void {
    this.button.icon = 'link';
    this.button.text = this.strings.insertLink;
    this.sub.add(
      this.button.click.subscribe(() => {
        if (this.editor.selectionText) {
          this.openModal();
        }
      }),
    );

    this.sub.add(
      this.editor.stateChange.subscribe(() => {
        const isDisabled = this.editor.isReadonly || !this.editor.selectionText;
        if (this.button.disabled !== isDisabled) {
          this.button.disabled = isDisabled;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.sub && this.sub.unsubscribe();
  }

  private openModal(): void {
    this.dialogService.showDialog(InsertLinkModalComponent, (instance, close) => {
      this.sub.add(instance.close$.subscribe((result) => close(result)));
      instance.editor = this.editor;
    });
  }
}
